import { Observable } from 'src/app/classes/observable';
import { ViewDidEnter, ViewWillEnter } from '@ionic/angular';
import { formatCurrency } from '@angular/common';
import { SaldoService } from './../../service/saldo.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-saldo',
  templateUrl: 'saldo.component.html',
  styleUrls: ['saldo.component.scss'],
})
export class SaldoComponent implements OnInit {
  
  @Input() clase = "saldo";
  @Input() class_dos = "saldo menos";
  public static saldoUsuario;
  public static cargandoSaldo = true;
  public static totalUsuario;
  public static noliquidadoUsuario;
  public mostrarSaldo= localStorage.getItem("saldoVisible") == "false" ? false : true;
  public ToggleIcon = 'eye-outline';

  constructor(public saldoService:SaldoService) {
    // Solo mostrar skeleton si no hay datos previos cargados
    if (!SaldoComponent.saldoUsuario) {
      this.setCargando(true);
    }
    Observable.suscribe("saldo",async ()=>{
      await this.saldoService.obtener_all().then((data: any) => {
        this.setSaldoUsuario( data.saldo_actual > 1000 ? formatCurrency(data.saldo_actual, 'es-AR', '$', 'ARS', '3.2-2') : formatCurrency(data.saldo_actual, 'es-AR', '$', 'ARS', '1.2-2'));
        this.setTotalUsuario( data.saldo_total > 1000 ? formatCurrency(data.saldo_total, 'es-AR', '$', 'ARS', '3.2-2') : formatCurrency(data.saldo_total, 'es-AR', '$', 'ARS', '1.2-2'));
        this.setnoliquidadoUsuario(data.saldo_no_liquidado > 1000 ? formatCurrency(data.saldo_no_liquidado, 'es-AR', '$', 'ARS', '3.2-2') : formatCurrency(data.saldo_no_liquidado, 'es-AR', '$', 'ARS', '1.2-2'));
        this.setCargando(false);
      });
    })
  }
  test(){
    return !(!SaldoComponent.cargandoSaldo && this.mostrarSaldo);
  }
  setnoliquidadoUsuario(data){
    SaldoComponent.noliquidadoUsuario=data;
  }
  getnoliquidadoUsuario(){
    return SaldoComponent.noliquidadoUsuario;
  }

  setTotalUsuario(data){
    SaldoComponent.totalUsuario=data;
  }
  getTotalUsuario(){
    return SaldoComponent.totalUsuario;
  }

  setSaldoUsuario(data){
    SaldoComponent.saldoUsuario=data;
  }
  getSaldoUsuario(){
    return SaldoComponent.saldoUsuario;
  }
  
  setCargando(valor){
    SaldoComponent.cargandoSaldo=valor;
  }
  getCargando(){
    return SaldoComponent.cargandoSaldo;
  }
  ngOnInit() {
    this.obtener_saldo();
    
  }

  async obtener_saldo() {
     
    
    Observable.notify("saldo",[]);
    setInterval(()=>{
      Observable.notify("saldo",[]);
    },300000)

    
  }
  
  toggleIcon(): void {
    this.mostrarSaldo = !this.mostrarSaldo;
    let saldoUsuarioSelector = document.querySelector(".saldoUsuario") as HTMLElement;
    if (this.mostrarSaldo == true) {
      this.ToggleIcon = 'eye-off-outline';
      saldoUsuarioSelector.innerHTML = this.getSaldoUsuario();
      localStorage.setItem("saldoVisible", "true");
    }
    else {
      this.ToggleIcon = 'eye-outline';
      saldoUsuarioSelector.innerHTML = "******";
      localStorage.setItem("saldoVisible", "false");
    }
  }
}
